import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  MenuItem,
  Typography,
  useTheme
} from '@material-ui/core'
import { Field, Form, Formik } from 'formik'
import { isArray } from 'lodash'
import { Clock, Plus } from 'lucide-react'
import { useEffect, useState } from 'react'
import { i18nToast } from '../../helpers/i18nToast'
import useSettings from '../../hooks/useSettings'
import api from '../../services/api'
import { i18n } from '../../translate/i18n'
import { ButtonPrimary } from '../ButtonPrimary'
import DepartmentUserScheduleModal from '../DepartmentUserScheduleModal'
import { InputFieldText } from '../InputFieldText'
import { InputSwitch } from '../InputSwitch'
import ScheduleQueueModal from '../ScheduleQueueModal'
import SelectInput from '../SelectInput'
import { useStyles } from './style'

const ScheduleFields = ({
  schedules,
  onSubmit,
  loading,
  labelSaveButton,
  classes
}) => {
  const [weekStartTime, setWeekStartTime] = useState('08:00')
  const [weekEndTime, setWeekEndTime] = useState('18:00')

  const [saturdayStartTime, setSaturdayStartTime] = useState('08:00')
  const [saturdayEndTime, setSaturdayEndTime] = useState('18:00')
  const [launchTimeSaturdayEnabled, setLaunchTimeSaturdayEnabled] =
    useState(false)

  const [sundayStartTime, setSundayStartTime] = useState('08:00')
  const [sundayEndTime, setSundayEndTime] = useState('18:00')

  const [launchTimeSundayEnabled, setLaunchTimeSundayEnabled] = useState(false)

  const [lunchWeekStartTime, setLunchWeekStartTime] = useState('11:00')
  const [lunchWeekEndTime, setLunchWeekEndTime] = useState('13:00')
  const [lunchSaturdayStartTime, setLunchSaturdayStartTime] = useState('11:00')
  const [lunchSaturdayEndTime, setLunchSaturdayEndTime] = useState('13:00')
  const [lunchSundayStartTime, setLunchSundayStartTime] = useState('11:00')
  const [lunchSundayEndTime, setLunchSundayEndTime] = useState('13:00')
  const [launchTimeEnabled, setLaunchTimeEnabled] = useState(false)

  const [holidayDate, setHolidayDate] = useState('')
  const [holidayStartTime, setHolidayStartTime] = useState('')
  const [holidayEndTime, setHolidayEndTime] = useState('')
  const [holidaySwitchEnabled, setHolidaySwitchEnabled] = useState(false)

  useEffect(() => {
    if (schedules && schedules.length > 0) {
      const weekDay = schedules.find((s, i) => i >= 0 && i <= 4 && s.startTimeA)
      if (weekDay) {
        setWeekStartTime(weekDay.startTimeA)
        setWeekEndTime(weekDay.endTimeA)
      }

      const saturday = schedules.find((s, i) => i === 5 && s.startTimeA)
      if (saturday) {
        setSaturdayStartTime(saturday.startTimeA)
        setSaturdayEndTime(saturday.endTimeA)
      }

      const sunday = schedules.find((s, i) => i === 6 && s.startTimeA)
      if (sunday) {
        setSundayStartTime(sunday.startTimeA)
        setSundayEndTime(sunday.endTimeA)
      }

      const weekLunchSchedule = schedules.find(
        (s, i) => i >= 0 && i <= 4 && s.startTimeB
      )
      if (weekLunchSchedule) {
        setLunchWeekStartTime(weekLunchSchedule.startTimeB)
        setLunchWeekEndTime(weekLunchSchedule.endTimeB)
      }

      const saturdayLunchSchedule = schedules.find(
        (s, i) => i === 5 && s.startTimeB
      )
      if (saturdayLunchSchedule) {
        setLunchSaturdayStartTime(saturdayLunchSchedule.startTimeB)
        setLunchSaturdayEndTime(saturdayLunchSchedule.endTimeB)
      }

      const sundayLunchSchedule = schedules.find(
        (s, i) => i === 6 && s.startTimeB
      )
      if (sundayLunchSchedule) {
        setLunchSundayStartTime(sundayLunchSchedule.startTimeB)
        setLunchSundayEndTime(sundayLunchSchedule.endTimeB)
      }

      if (schedules.some((s, i) => i >= 0 && i <= 4 && s.startTimeB)) {
        setLaunchTimeEnabled(true)
      }
      if (schedules.some((s, i) => i === 5 && s.startTimeB)) {
        setLaunchTimeSaturdayEnabled(true)
      }
      if (schedules.some((s, i) => i === 6 && s.startTimeB)) {
        setLaunchTimeSundayEnabled(true)
      }
    }
  }, [schedules])

  const scheduleType = schedules.type === 'company' ? 'Departamento' : 'Empresa'
  const schedulesLabel = `Horário de Expediente por ${scheduleType}`

  const days = [
    { label: 'Seg', index: 0 },
    { label: 'Ter', index: 1 },
    { label: 'Qua', index: 2 },
    { label: 'Qui', index: 3 },
    { label: 'Sex', index: 4 },
    { label: 'Sáb', index: 5 },
    { label: 'Dom', index: 6 }
  ]

  return (
    <Grid container className={classes.boxGrid}>
      <h2 className={classes.groupTitle}>{schedulesLabel}</h2>
      <Formik
        enableReinitialize
        className={classes.fullWidth}
        initialValues={{ schedules }}
        onSubmit={({ schedules }) =>
          setTimeout(() => {
            onSubmit(schedules)
          }, 500)
        }
      >
        {({ values, setFieldValue }) => {
          const showWeekTime =
            values.schedules &&
            values.schedules.some(
              (s, index) => s.checked && index >= 0 && index <= 4
            )

          const showSaturdayTime =
            values.schedules &&
            values.schedules.some(
              (s, index) => s.checked && index >= 5 && index <= 5
            )

          const showSundayTime =
            values.schedules &&
            values.schedules.some(
              (s, index) => s.checked && index >= 6 && index <= 6
            )

          return (
            <Form className={classes.fullWidth}>
              <Grid container spacing={2}>
                <Grid item xs={12} className={classes.contentFormGroup}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend" className={classes.formLabel}>
                      Selecione os dias que a empresa funciona
                    </FormLabel>
                    <FormGroup row>
                      {days.map(day => (
                        <Field
                          name={`schedules[${day.index}].checked`}
                          key={day.index}
                        >
                          {({ field, form }) => (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  {...field}
                                  className={classes.checkbox}
                                  checked={field.value || false}
                                  onChange={e => {
                                    const isChecked = e.target.checked
                                    form.setFieldValue(field.name, isChecked)
                                    if (isChecked) {
                                      if (day.index >= 0 && day.index <= 4) {
                                        form.setFieldValue(
                                          `schedules[${day.index}].startTimeA`,
                                          weekStartTime
                                        )
                                        form.setFieldValue(
                                          `schedules[${day.index}].endTimeA`,
                                          weekEndTime
                                        )
                                        if (launchTimeEnabled) {
                                          form.setFieldValue(
                                            `schedules[${day.index}].startTimeB`,
                                            lunchWeekStartTime
                                          )
                                          form.setFieldValue(
                                            `schedules[${day.index}].endTimeB`,
                                            lunchWeekEndTime
                                          )
                                        }
                                      } else if (day.index === 5) {
                                        form.setFieldValue(
                                          `schedules[${day.index}].startTimeA`,
                                          saturdayStartTime
                                        )
                                        form.setFieldValue(
                                          `schedules[${day.index}].endTimeA`,
                                          saturdayEndTime
                                        )
                                        if (launchTimeSaturdayEnabled) {
                                          form.setFieldValue(
                                            `schedules[${day.index}].startTimeB`,
                                            lunchSaturdayStartTime
                                          )
                                          form.setFieldValue(
                                            `schedules[${day.index}].endTimeB`,
                                            lunchSaturdayEndTime
                                          )
                                        }
                                      } else if (day.index === 6) {
                                        form.setFieldValue(
                                          `schedules[${day.index}].startTimeA`,
                                          sundayStartTime
                                        )
                                        form.setFieldValue(
                                          `schedules[${day.index}].endTimeA`,
                                          sundayEndTime
                                        )
                                        if (launchTimeSundayEnabled) {
                                          form.setFieldValue(
                                            `schedules[${day.index}].startTimeB`,
                                            lunchSundayStartTime
                                          )
                                          form.setFieldValue(
                                            `schedules[${day.index}].endTimeB`,
                                            lunchSundayEndTime
                                          )
                                        }
                                      }
                                    } else {
                                      form.setFieldValue(
                                        `schedules[${day.index}].startTimeA`,
                                        ''
                                      )
                                      form.setFieldValue(
                                        `schedules[${day.index}].endTimeA`,
                                        ''
                                      )
                                      form.setFieldValue(
                                        `schedules[${day.index}].startTimeB`,
                                        ''
                                      )
                                      form.setFieldValue(
                                        `schedules[${day.index}].endTimeB`,
                                        ''
                                      )
                                    }
                                  }}
                                  color="primary"
                                />
                              }
                              label={day.label}
                              className={classes.formLabel}
                            />
                          )}
                        </Field>
                      ))}
                    </FormGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12} className={classes.contentFormGrid}>
                  <div
                    className={classes.boxShowWeekTime}
                    style={{
                      height: holidaySwitchEnabled ? 'auto' : '50px',
                      width: '254px'
                    }}
                  >
                    <FormControl className={classes.formControl}>
                      <InputSwitch
                        label="Ativar modo feriado"
                        size="small"
                        onChange={e => {
                          setHolidaySwitchEnabled(e.target.checked)
                        }}
                        checked={holidaySwitchEnabled}
                      />
                      {holidaySwitchEnabled && (
                        <>
                          <FormLabel
                            component="legend"
                            className={classes.formLabel}
                          >
                            Data e horário do feriado
                          </FormLabel>
                          <InputFieldText
                            type="date"
                            value={holidayDate}
                            onChange={e => {
                              setHolidayDate(e.target.value)
                            }}
                            InputLabelProps={{
                              shrink: true
                            }}
                          />
                          <div className={classes.inputWrapper}>
                            <InputFieldText
                              type="time"
                              value={holidayStartTime}
                              onChange={e => {
                                const newStartTime = e.target.value
                                setHolidayStartTime(newStartTime)
                                const newSchedules = values.schedules.map(
                                  (schedule, index) =>
                                    schedule.checked && index >= 0 && index <= 4
                                      ? {
                                          ...schedule,
                                          startTimeA: newStartTime
                                        }
                                      : schedule
                                )
                                setFieldValue('schedules', newSchedules)
                                e.target.blur()
                              }}
                              InputLabelProps={{
                                shrink: true
                              }}
                            />
                            <span className={classes.textUntil}>até</span>
                            <InputFieldText
                              type="time"
                              value={holidayEndTime}
                              onChange={e => {
                                const newEndTime = e.target.value
                                setHolidayEndTime(newEndTime)
                                const newSchedules = values.schedules.map(
                                  (schedule, index) =>
                                    schedule.checked && index >= 0 && index <= 4
                                      ? { ...schedule, endTimeA: newEndTime }
                                      : schedule
                                )
                                setFieldValue('schedules', newSchedules)
                                e.target.blur()
                              }}
                              InputLabelProps={{
                                shrink: true
                              }}
                            />
                          </div>
                        </>
                      )}
                    </FormControl>
                  </div>

                  {showWeekTime && (
                    <div
                      className={classes.boxShowWeekTime}
                      style={{ height: launchTimeEnabled ? 'auto' : '120px' }}
                    >
                      <FormControl className={classes.formControl}>
                        <FormLabel
                          component="legend"
                          className={classes.formLabel}
                        >
                          Horário durante a semana
                        </FormLabel>
                        <div className={classes.inputWrapper}>
                          <InputFieldText
                            type="time"
                            value={weekStartTime}
                            onChange={e => {
                              const newStartTime = e.target.value
                              setWeekStartTime(newStartTime)
                              const newSchedules = values.schedules.map(
                                (schedule, index) =>
                                  schedule.checked && index >= 0 && index <= 4
                                    ? { ...schedule, startTimeA: newStartTime }
                                    : schedule
                              )
                              setFieldValue('schedules', newSchedules)
                              e.target.blur()
                            }}
                            InputLabelProps={{
                              shrink: true
                            }}
                          />
                          <span className={classes.textUntil}>até</span>
                          <InputFieldText
                            type="time"
                            value={weekEndTime}
                            onChange={e => {
                              const newEndTime = e.target.value
                              setWeekEndTime(newEndTime)
                              const newSchedules = values.schedules.map(
                                (schedule, index) =>
                                  schedule.checked && index >= 0 && index <= 4
                                    ? { ...schedule, endTimeA: newEndTime }
                                    : schedule
                              )
                              setFieldValue('schedules', newSchedules)
                              e.target.blur()
                            }}
                            InputLabelProps={{
                              shrink: true
                            }}
                          />
                        </div>
                        <InputSwitch
                          label="Adicionar horário de almoço"
                          size="small"
                          onChange={e => {
                            const isEnabled = e.target.checked
                            setLaunchTimeEnabled(isEnabled)
                            const newSchedules = values.schedules.map(
                              (schedule, index) => {
                                if (
                                  schedule.checked &&
                                  index >= 0 &&
                                  index <= 4
                                ) {
                                  return {
                                    ...schedule,
                                    startTimeB: isEnabled
                                      ? lunchWeekStartTime
                                      : '',
                                    endTimeB: isEnabled ? lunchWeekEndTime : ''
                                  }
                                }
                                return schedule
                              }
                            )
                            setFieldValue('schedules', newSchedules)
                          }}
                          checked={launchTimeEnabled}
                        />
                        {launchTimeEnabled && (
                          <div className={classes.inputWrapper}>
                            <InputFieldText
                              type="time"
                              value={lunchWeekStartTime}
                              onChange={e => {
                                const newStartTime = e.target.value
                                setLunchWeekStartTime(newStartTime)
                                const newSchedules = values.schedules.map(
                                  (schedule, index) =>
                                    schedule.checked && index >= 0 && index <= 4
                                      ? {
                                          ...schedule,
                                          startTimeB: newStartTime
                                        }
                                      : schedule
                                )
                                setFieldValue('schedules', newSchedules)
                                e.target.blur()
                              }}
                              InputLabelProps={{
                                shrink: true
                              }}
                            />
                            <span className={classes.textUntil}>até</span>
                            <InputFieldText
                              type="time"
                              value={lunchWeekEndTime}
                              onChange={e => {
                                const newEndTime = e.target.value
                                setLunchWeekEndTime(newEndTime)
                                const newSchedules = values.schedules.map(
                                  (schedule, index) =>
                                    schedule.checked && index >= 0 && index <= 4
                                      ? { ...schedule, endTimeB: newEndTime }
                                      : schedule
                                )
                                setFieldValue('schedules', newSchedules)
                                e.target.blur()
                              }}
                              InputLabelProps={{
                                shrink: true
                              }}
                            />
                          </div>
                        )}
                      </FormControl>
                    </div>
                  )}

                  {showSaturdayTime && (
                    <div
                      className={classes.boxShowWeekTime}
                      style={{
                        height: launchTimeSaturdayEnabled ? 'auto' : '120px'
                      }}
                    >
                      <FormControl className={classes.formControl}>
                        <FormLabel
                          component="legend"
                          className={classes.formLabel}
                        >
                          Horário durante os sábados
                        </FormLabel>
                        <div className={classes.inputWrapper}>
                          <InputFieldText
                            type="time"
                            value={saturdayStartTime}
                            onChange={e => {
                              const newStartTime = e.target.value
                              setSaturdayStartTime(newStartTime)
                              const newSchedules = values.schedules.map(
                                (schedule, index) =>
                                  schedule.checked && index === 5
                                    ? { ...schedule, startTimeA: newStartTime }
                                    : schedule
                              )
                              setFieldValue('schedules', newSchedules)
                              e.target.blur()
                            }}
                            InputLabelProps={{
                              shrink: true
                            }}
                          />
                          <span className={classes.textUntil}>até</span>
                          <InputFieldText
                            type="time"
                            value={saturdayEndTime}
                            onChange={e => {
                              const newEndTime = e.target.value
                              setSaturdayEndTime(newEndTime)
                              const newSchedules = values.schedules.map(
                                (schedule, index) =>
                                  schedule.checked && index === 5
                                    ? { ...schedule, endTimeA: newEndTime }
                                    : schedule
                              )
                              setFieldValue('schedules', newSchedules)
                              e.target.blur()
                            }}
                            InputLabelProps={{
                              shrink: true
                            }}
                          />
                        </div>
                        <InputSwitch
                          label="Adicionar horário de almoço"
                          size="small"
                          onChange={e => {
                            const isEnabled = e.target.checked
                            setLaunchTimeSaturdayEnabled(isEnabled)
                            const newSchedules = values.schedules.map(
                              (schedule, index) => {
                                if (schedule.checked && index === 5) {
                                  return {
                                    ...schedule,
                                    startTimeB: isEnabled
                                      ? lunchSaturdayStartTime
                                      : '',
                                    endTimeB: isEnabled
                                      ? lunchSaturdayEndTime
                                      : ''
                                  }
                                }
                                return schedule
                              }
                            )
                            setFieldValue('schedules', newSchedules)
                          }}
                          checked={launchTimeSaturdayEnabled}
                        />
                        {launchTimeSaturdayEnabled && (
                          <div className={classes.inputWrapper}>
                            <InputFieldText
                              type="time"
                              value={lunchSaturdayStartTime}
                              onChange={e => {
                                const newStartTime = e.target.value
                                setLunchSaturdayStartTime(newStartTime)
                                const newSchedules = values.schedules.map(
                                  (schedule, index) =>
                                    schedule.checked && index === 5
                                      ? {
                                          ...schedule,
                                          startTimeB: newStartTime
                                        }
                                      : schedule
                                )
                                setFieldValue('schedules', newSchedules)
                                e.target.blur()
                              }}
                              InputLabelProps={{
                                shrink: true
                              }}
                            />
                            <span className={classes.textUntil}>até</span>
                            <InputFieldText
                              type="time"
                              value={lunchSaturdayEndTime}
                              onChange={e => {
                                const newEndTime = e.target.value
                                setLunchSaturdayEndTime(newEndTime)
                                const newSchedules = values.schedules.map(
                                  (schedule, index) =>
                                    schedule.checked && index === 5
                                      ? { ...schedule, endTimeB: newEndTime }
                                      : schedule
                                )
                                setFieldValue('schedules', newSchedules)
                                e.target.blur()
                              }}
                              InputLabelProps={{
                                shrink: true
                              }}
                            />
                          </div>
                        )}
                      </FormControl>
                    </div>
                  )}

                  {showSundayTime && (
                    <div
                      className={classes.boxShowWeekTime}
                      style={{
                        height: launchTimeSundayEnabled ? 'auto' : '120px'
                      }}
                    >
                      <FormControl className={classes.formControl}>
                        <FormLabel
                          component="legend"
                          className={classes.formLabel}
                        >
                          Horário durante os domingos
                        </FormLabel>
                        <div className={classes.inputWrapper}>
                          <InputFieldText
                            type="time"
                            value={sundayStartTime}
                            onChange={e => {
                              const newStartTime = e.target.value
                              setSundayStartTime(newStartTime)
                              const newSchedules = values.schedules.map(
                                (schedule, index) =>
                                  schedule.checked && index === 6
                                    ? { ...schedule, startTimeA: newStartTime }
                                    : schedule
                              )
                              setFieldValue('schedules', newSchedules)
                              e.target.blur()
                            }}
                            InputLabelProps={{
                              shrink: true
                            }}
                          />
                          <span className={classes.textUntil}>até</span>
                          <InputFieldText
                            type="time"
                            value={sundayEndTime}
                            onChange={e => {
                              const newEndTime = e.target.value
                              setSundayEndTime(newEndTime)
                              const newSchedules = values.schedules.map(
                                (schedule, index) =>
                                  schedule.checked && index === 6
                                    ? { ...schedule, endTimeA: newEndTime }
                                    : schedule
                              )
                              setFieldValue('schedules', newSchedules)
                              e.target.blur()
                            }}
                            InputLabelProps={{
                              shrink: true
                            }}
                          />
                        </div>
                        <InputSwitch
                          label="Adicionar horário de almoço"
                          size="small"
                          onChange={e => {
                            const isEnabled = e.target.checked
                            setLaunchTimeSundayEnabled(isEnabled)
                            const newSchedules = values.schedules.map(
                              (schedule, index) => {
                                if (schedule.checked && index === 6) {
                                  return {
                                    ...schedule,
                                    startTimeB: isEnabled
                                      ? lunchSundayStartTime
                                      : '',
                                    endTimeB: isEnabled
                                      ? lunchSundayEndTime
                                      : ''
                                  }
                                }
                                return schedule
                              }
                            )
                            setFieldValue('schedules', newSchedules)
                          }}
                          checked={launchTimeSundayEnabled}
                        />
                        {launchTimeSundayEnabled && (
                          <div className={classes.inputWrapper}>
                            <InputFieldText
                              type="time"
                              value={lunchSundayStartTime}
                              onChange={e => {
                                const newStartTime = e.target.value
                                setLunchSundayStartTime(newStartTime)
                                const newSchedules = values.schedules.map(
                                  (schedule, index) =>
                                    schedule.checked && index === 6
                                      ? {
                                          ...schedule,
                                          startTimeB: newStartTime
                                        }
                                      : schedule
                                )
                                setFieldValue('schedules', newSchedules)
                                e.target.blur()
                              }}
                              InputLabelProps={{
                                shrink: true
                              }}
                            />
                            <span className={classes.textUntil}>até</span>
                            <InputFieldText
                              type="time"
                              value={lunchSundayEndTime}
                              onChange={e => {
                                const newEndTime = e.target.value
                                setLunchSundayEndTime(newEndTime)
                                const newSchedules = values.schedules.map(
                                  (schedule, index) =>
                                    schedule.checked && index === 6
                                      ? { ...schedule, endTimeB: newEndTime }
                                      : schedule
                                )
                                setFieldValue('schedules', newSchedules)
                                e.target.blur()
                              }}
                              InputLabelProps={{
                                shrink: true
                              }}
                            />
                          </div>
                        )}
                      </FormControl>
                    </div>
                  )}
                </Grid>
              </Grid>
              <div className={classes.buttonContainer}>
                <ButtonPrimary
                  loading={loading}
                  type="submit"
                  color="primary"
                  variant="contained"
                  label={
                    labelSaveButton ?? i18n.t('whatsappModal.buttons.okEdit')
                  }
                />
              </div>
            </Form>
          )
        }}
      </Formik>
    </Grid>
  )
}

const Departments = ({ classes, scheduleType, handleOpenModal, queues }) => {
  const type = scheduleType === 'queue' ? 'Departamento' : 'Empresa'
  const schedulesLabel = `Horário de Expediente por ${type}`
  const theme = useTheme()

  return (
    <Grid item xs={12} className={classes.boxGrid}>
      <h3 className={classes.groupTitle}>{schedulesLabel}</h3>

      <Grid container spacing={2} className={classes.queueContainer}>
        {queues.map(queue => {
          const hasSchedule =
            isArray(queue.schedules) &&
            queue.schedules.length > 0 &&
            queue.schedules.some(s => s.startTimeA)

          return (
            <div key={queue.id} className={classes.queueItem}>
              <span>{queue.name}</span>
              <IconButton
                className={classes.iconButton}
                onClick={() => handleOpenModal(queue)}
              >
                <Clock
                  size={16}
                  color={
                    hasSchedule
                      ? theme.palette.blue_300.main
                      : theme.palette.red_100.main
                  }
                />
              </IconButton>
            </div>
          )
        })}
      </Grid>
    </Grid>
  )
}

function SchedulesForm(props) {
  const {
    initialValues,
    onSubmit,
    loading,
    labelSaveButton,
    settings,
    onScheduleTypeChange
  } = props
  const classes = useStyles()

  const [modalOpen, setModalOpen] = useState(false)
  const [selectedQueue, setSelectedQueue] = useState(null)
  const [selectedQueueSchedules, setSelectedQueueSchedules] = useState(null)
  const [queues, setQueues] = useState([])

  const [, setDailyTicketReset] = useState('disabled')
  const [scheduleType, setScheduleType] = useState()
  const [, setOutOfHoursAction] = useState('pending')
  const [serverClock, setServerClock] = useState(null)
  const [serverClockTick, setServerClockTick] = useState(0)
  const { getServerTime, update } = useSettings()

  const [userScheduleModalOpen, setUserScheduleModalOpen] = useState(false)
  const [savedSchedules, setSavedSchedules] = useState([])

  const [selectedScheduleId, setSelectedScheduleId] = useState(null)

  useEffect(() => {
    fetchSavedSchedules()
  }, [])

  useEffect(() => {
    let isMounted = true

    const syncServerClock = async () => {
      try {
        const data = await getServerTime()

        if (!isMounted) {
          return
        }

        setServerClock({
          timestamp: Number(data?.timestamp),
          timeZone: data?.timeZone || 'UTC',
          syncedAt: performance.now()
        })
      } catch {
        if (isMounted) {
          setServerClock(null)
        }
      }
    }

    syncServerClock()

    const resyncInterval = setInterval(syncServerClock, 30000)
    const tickInterval = setInterval(() => {
      setServerClockTick(previous => previous + 1)
    }, 1000)

    return () => {
      isMounted = false
      clearInterval(resyncInterval)
      clearInterval(tickInterval)
    }
  }, [getServerTime])

  useEffect(() => {
    if (Array.isArray(settings) && settings.length) {
      const dailyTicketResetData = settings.find(
        s => s.key === 'dailyTicketReset'
      )
      setDailyTicketReset(dailyTicketResetData?.value || 'disabled')

      const scheduleTypeData = settings.find(s => s.key === 'scheduleType')
      setScheduleType(scheduleTypeData?.value || 'disabled')

      const outOfHoursActionData = settings.find(
        s => s.key === 'outOfHoursAction'
      )
      setOutOfHoursAction(outOfHoursActionData?.value || 'pending')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings])

  useEffect(() => {
    if (scheduleType === 'queue') {
      const fetchQueues = async () => {
        try {
          const { data } = await api.get('/queue')
          const filteredQueues = data.filter(
            queue => queue.isBot === false && queue.notificationact === false
          )
          setQueues(filteredQueues)
        } catch (error) {
          i18nToast.error('Não foi possível buscar os departamentos.')
        }
      }
      fetchQueues()
    }
  }, [scheduleType])

  const fetchSavedSchedules = async () => {
    try {
      const { data } = await api.get('/users/work-schedule-templates')
      setSavedSchedules(Array.isArray(data) ? data : [])
    } catch {
      i18nToast.error('Não foi possível buscar os horários salvos.')
    }
  }

  const getServerClockDisplay = () => {
    if (!serverClock?.timestamp) {
      return {
        time: '--:--:--',
        timeZone: i18n.t('settings.serverClock.unavailable')
      }
    }

    const estimatedNow = new Date(
      serverClock.timestamp + (performance.now() - serverClock.syncedAt)
    )

    const formatter = new Intl.DateTimeFormat('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      timeZone: serverClock.timeZone
    })

    return {
      time: formatter.format(estimatedNow),
      timeZone: serverClock.timeZone
    }
  }

  const serverClockDisplay = getServerClockDisplay(serverClockTick)

  const initialSchedules = [
    {
      weekday: i18n.t('queueModal.serviceHours.monday'),
      weekdayEn: 'monday',
      startTimeA: '08:00',
      endTimeA: '18:00',
      startTimeB: '',
      endTimeB: '',
      checked: true
    },
    {
      weekday: i18n.t('queueModal.serviceHours.tuesday'),
      weekdayEn: 'tuesday',
      startTimeA: '08:00',
      endTimeA: '18:00',
      startTimeB: '',
      endTimeB: '',
      checked: true // <- Marcado por padrão
    },
    {
      weekday: i18n.t('queueModal.serviceHours.wednesday'),
      weekdayEn: 'wednesday',
      startTimeA: '08:00',
      endTimeA: '18:00',
      startTimeB: '',
      endTimeB: '',
      checked: true // <- Marcado por padrão
    },
    {
      weekday: i18n.t('queueModal.serviceHours.thursday'),
      weekdayEn: 'thursday',
      startTimeA: '08:00',
      endTimeA: '18:00',
      startTimeB: '',
      endTimeB: '',
      checked: true // <- Marcado por padrão
    },
    {
      weekday: i18n.t('queueModal.serviceHours.friday'),
      weekdayEn: 'friday',
      startTimeA: '08:00',
      endTimeA: '18:00',
      startTimeB: '',
      endTimeB: '',
      checked: true // <- Marcado por padrão
    },
    {
      weekday: i18n.t('queueModal.serviceHours.saturday'),
      weekdayEn: 'saturday',
      startTimeA: '',
      endTimeA: '',
      startTimeB: '',
      endTimeB: '',
      checked: false // Sábado desmarcado por padrão
    },
    {
      weekday: i18n.t('queueModal.serviceHours.sunday'),
      weekdayEn: 'sunday',
      startTimeA: '',
      endTimeA: '',
      startTimeB: '',
      endTimeB: '',
      checked: false // Domingo desmarcado por padrão
    }
  ]

  const [schedules, setSchedules] = useState(initialSchedules)

  useEffect(() => {
    if (isArray(initialValues) && initialValues.length > 0) {
      setSchedules(initialValues)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues])

  const handleOpenModal = async queue => {
    try {
      const { data } = await api.get(`/queue/${queue.id}`)
      const queueSchedules = data.schedules

      const hasValidSchedule =
        isArray(queueSchedules) &&
        queueSchedules.some(s => s.startTimeA && s.startTimeA.trim() !== '')

      // Se tiver horário válido, usa o do banco. Se for vazio/novo, usa o nosso initialSchedules padrão.
      const schedulesData = hasValidSchedule ? queueSchedules : initialSchedules

      setSelectedQueue(queue)
      setSelectedQueueSchedules(schedulesData)
      setModalOpen(true)
    } catch (error) {
      console.error('Erro ao buscar horários da fila:', error)
      i18nToast.error('Não foi possível buscar os horários do departamento.')
    }
  }

  const handleCloseModal = () => {
    setModalOpen(false)
    setSelectedQueue(null)
    setSelectedQueueSchedules(null)
  }

  const handleSaveQueueSchedules = async schedulesData => {
    if (!selectedQueue) return

    try {
      await api.put(`/queue/${selectedQueue.id}`, {
        schedules: schedulesData
      })
      i18nToast.success('Horários do departamento atualizados com sucesso!')
      setQueues(prevQueues =>
        prevQueues.map(q =>
          q.id === selectedQueue.id ? { ...q, schedules: schedulesData } : q
        )
      )
      window.dispatchEvent(new CustomEvent('queues-updated'))
      handleCloseModal()
    } catch (error) {
      console.error('Erro ao salvar horários da fila:', error)
      i18nToast.error('Não foi possível salvar os horários do departamento.')
    }
  }

  const handleSubmit = data => {
    onSubmit(data)
  }

  async function handleScheduleType(value) {
    setScheduleType(value)
    await update({
      key: 'scheduleType',
      value
    })
    i18nToast.success('settings.success')
    if (typeof onScheduleTypeChange === 'function') {
      onScheduleTypeChange(value)
    }
  }

  return (
    <Grid container className={classes.boxContentGroup}>
      <Grid item xs={12} className={classes.boxGrid}>
        <h3 className={classes.groupTitle}>
          {/* {i18n.t('settings.group.officeHours')} */}
          Expediente
        </h3>

        <Grid item xs={12} className={classes.boxContentInput}>
          <Grid item xs={12} sm={6} md={3}>
            <SelectInput
              label={i18n.t('settings.OfficeManagement.title')}
              id="schedule-type-label"
              value={scheduleType}
              onChange={async e => {
                handleScheduleType(e.target.value)
              }}
            >
              <MenuItem value={'disabled'}>
                {i18n.t('settings.OfficeManagement.options.disabled')}
              </MenuItem>
              <MenuItem value={'queue'}>
                {i18n.t(
                  'settings.OfficeManagement.options.ManagementByDepartment'
                )}
              </MenuItem>
              <MenuItem value={'company'}>
                {i18n.t(
                  'settings.OfficeManagement.options.ManagementByCompany'
                )}
              </MenuItem>
            </SelectInput>
          </Grid>
          <Grid item xs={2} style={{maxWidth: '220px'}}>
            <div className={classes.serverClock}>
              <div className={classes.serverClockIcon}>
                <Clock size={18} />
              </div>
              <div className={classes.serverClockInfo}>
                <Typography
                  component="span"
                  className={classes.serverClockLabel}
                >
                  {i18n.t('settings.serverClock.label')}
                </Typography>
                <div className={classes.serverClockValueContainer}>
                  <Typography
                    component="span"
                    className={classes.serverClockValue}
                  >
                    {serverClockDisplay.time}
                  </Typography>
                  <Typography
                    component="span"
                    className={classes.serverClockTimezone}
                  >
                    {serverClockDisplay.timeZone}
                  </Typography>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
        {/* {(scheduleType === 'company' || scheduleType === 'queue') && (
          <Grid item xs={2} className={classes.boxHours}>
            <span>
              <strong>Atenção!</strong>Utilize o Horário de Brasília
            </span>
          </Grid>
        )} */}
      </Grid>

      {scheduleType === 'company' && (
        <Grid item xs={12} className={classes.boxContentInput}>
          <Grid item xs={12}>
            <ScheduleFields
              schedules={schedules}
              onSubmit={handleSubmit}
              loading={loading}
              labelSaveButton={labelSaveButton}
              classes={classes}
            />
          </Grid>
        </Grid>
      )}

      {scheduleType === 'queue' && (
        <Grid item xs={12} className={classes.boxContentInput}>
          <Grid item xs={12}>
            <Departments
              classes={classes}
              scheduleType={scheduleType}
              handleOpenModal={handleOpenModal}
              queues={queues}
            />
          </Grid>
        </Grid>
      )}

      {selectedQueue && selectedQueueSchedules && (
        <ScheduleQueueModal
          open={modalOpen}
          onClose={handleCloseModal}
          schedules={selectedQueueSchedules}
          onSubmit={handleSaveQueueSchedules}
          loading={loading}
          scheduleType="queue"
        />
      )}

      <Grid item xs={12} className={classes.boxGrid}>
        <h3 className={classes.groupTitle}>Expediente dos Usuários</h3>
        <Grid container spacing={2} className={classes.queueContainer}>
          {/* Renderiza os turnos cadastrados como botões (estilo Departamentos) */}
          {savedSchedules.map(schedule => (
            <div key={schedule.id} className={classes.queueItem}>
              <span>{schedule.name}</span>
              <IconButton
                className={classes.iconButton}
                onClick={() => {
                  setSelectedScheduleId(schedule.id)
                  setUserScheduleModalOpen(true)
                }}
              >
                <Clock size={16} />
              </IconButton>
            </div>
          ))}

          <Button
            color="primary"
            // variant="outlined"
            onClick={() => {
              setSelectedScheduleId(null)
              setUserScheduleModalOpen(true)
            }}
            className={classes.buttonAddNewHour}
          >
            <span>
              Novo Horário
              <Plus size={20} />
            </span>
          </Button>
        </Grid>
        <DepartmentUserScheduleModal
          open={userScheduleModalOpen}
          scheduleId={selectedScheduleId}
          onClose={() => setUserScheduleModalOpen(false)}
          onSave={fetchSavedSchedules}
        />
      </Grid>
    </Grid>
  )
}

export default SchedulesForm
